/**
 * Canonical Creator (FINAL — CREATOR) paths.
 * Old /dashboard/content/* and /dashboard/analytics redirect here.
 */
export const CREATOR = {
  home: '/dashboard',
  music: '/dashboard/music',
  musicReleases: '/dashboard/music/releases',
  musicTracks: '/dashboard/music/tracks',
  musicDrafts: '/dashboard/music/drafts',
  upload: '/dashboard/music/upload',
  publish: '/dashboard/music/publish',
  albumNew: '/dashboard/music/releases/new',
  album: (uuid) => `/dashboard/music/releases/${uuid}`,
  albumEdit: (uuid) => `/dashboard/music/releases/${uuid}/edit`,
  track: (uuid) => `/dashboard/music/tracks/${uuid}`,
  trackEdit: (uuid) => `/dashboard/music/tracks/${uuid}/edit`,
  sales: '/dashboard/sales',
  audience: '/dashboard/audience',
  profile: '/dashboard/profile',
  settings: '/dashboard/settings',
  playlists: '/dashboard/playlists',
  playlist: (id) => `/dashboard/playlists/${id}`,
  playlistEdit: (id) => `/dashboard/playlists/${id}/edit`,
  purchased: '/dashboard/purchased',
  plans: '/plans',
};

export default CREATOR;
